import cn from 'classnames';

import styles from 'styles/components/checkout/caap/contentBox.scss';

const ContentBox = params => {
  const {
    children,
    clearAfter,
    clearAfterWithSpace,
    header,
    isFirst,
    isLast,
    isListItemContainer,
    isNoBorder,
    isNonRadio,
    isNoPadding,
    isPromoCheckbox,
    isSelected,
    isSolo,
    showOnlySmallScreen
  } = params;

  const itemBoxStyles = cn(
    {
      [styles.clearAfter]: clearAfter,
      [styles.itemBox]: true,
      [styles.selected]: isSelected,
      [styles.noBorder]: isNoBorder,
      [styles.solo]: isSolo,
      [styles.first]: isFirst,
      [styles.last]: isLast
    }
  );

  const itemStyles = cn(
    {
      [styles.item]: true,
      [styles.noPadding]: isNoPadding,
      [styles.nonRadio]: isNonRadio,
      [styles.promoCheckbox]: isPromoCheckbox
    }
  );

  const itemContainerStyles = cn(
    {
      [styles.itemContainer]: true,
      [styles.listItemContainer]: isListItemContainer,
      [styles.showOnlySmallScreen]: showOnlySmallScreen,
      [styles.clearAfter]: clearAfter,
      [styles.clearAfterWithSpace]: clearAfterWithSpace
    }
  );

  return (
    <div className={itemContainerStyles}>
      <div className={itemBoxStyles}>
        { header ? <div><h4>{header}</h4></div> : null }
        <div className={itemStyles}>
          { children }
        </div>
      </div>
    </div>
  );
};

export default ContentBox;
